
import { SearchCriteria } from "./search-criteria";

export class CategoryBranchSearchCriteria extends SearchCriteria {


}
